/* ============================================================
   NATURE'S HERO — matched set with sections/natures-hero.liquid
   - Entrance animation: adds .is-ready once painted, triggering
     the logo/Shop-cue fade+slide defined in the section's CSS.
   - Scroll shrink: as the hero scrolls up under the sticky header,
     writes --logo-scale / --logo-opacity / --logo-shift onto the
     logo wrapper so it shrinks, fades, and nudges upward — reading
     as it "tucking into" the header.
   - Fully skips the scroll-driven effect under prefers-reduced-motion;
     content is just shown, no sticking/shrinking/bobbing.
   No dependencies. Vanilla JS.
   ============================================================ */
(function () {
  var MIN_SCALE = 0.34;
  var MIN_OPACITY = 0;
  var SHIFT_PX = -34;

  function init() {
    var heroes = document.querySelectorAll('[data-natures-hero]');
    if (!heroes.length) return;
    heroes.forEach(setup);
  }

  function setup(hero) {
    if (hero.dataset.nhReady === '1') return;
    hero.dataset.nhReady = '1';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------------- entrance animation ---------------- */
    function reveal() { hero.classList.add('is-ready'); }
    if (reduceMotion) {
      reveal();
    } else {
      requestAnimationFrame(function () { requestAnimationFrame(reveal); });
    }

    /* ---------------- smooth-scroll the Shop cue ---------------- */
    var shopLink = hero.querySelector('[data-nh-shop][data-nh-smooth]');
    if (shopLink) {
      shopLink.addEventListener('click', function (e) {
        var hash = shopLink.getAttribute('href');
        if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return;
        var target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* ---------------- scroll-linked logo shrink ---------------- */
    if (reduceMotion) return; // CSS already pins the logo static in this case

    var logoWrap = hero.querySelector('[data-nh-logo-wrap]');
    if (!logoWrap) return;

    function fadeDistance() {
      return Math.max(220, hero.offsetHeight * 0.55);
    }

    var ticking = false;
    function update() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      var dist = fadeDistance();
      var progress = Math.min(Math.max(-rect.top / dist, 0), 1);

      var scale = 1 + (MIN_SCALE - 1) * progress;
      var opacity = 1 + (MIN_OPACITY - 1) * progress;
      var shift = SHIFT_PX * progress;

      logoWrap.style.setProperty('--logo-scale', scale.toFixed(3));
      logoWrap.style.setProperty('--logo-opacity', opacity.toFixed(3));
      logoWrap.style.setProperty('--logo-shift', shift.toFixed(1) + 'px');
      logoWrap.style.pointerEvents = progress >= 0.98 ? 'none' : '';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Shopify theme editor: re-init when the section is reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target && e.target.querySelector ? e.target.querySelector('[data-natures-hero]') : null;
    if (hero) hero.dataset.nhReady = '';
    init();
  });
})();
